import AuthLayout from '../AuthLayout';
import ResetPassword from '../Forms/ResetPassword';

const ResetPasswordPage = () => {
  return (
    <AuthLayout title="Reset Password" subtitle="">
      <ResetPassword />
    </AuthLayout>
  );
};

export default ResetPasswordPage;
